const key = 'styleSeeker'
export default key
